import { ICON__dove_solid, ICON__gratipay_brands, ICON__heart_pulse_solid, ICON__user_group_solid, ICON__wine_glass_solid } from '@/assets/icons_fa';
import { use_slice_user } from '@/hooks/store/use_slices';
import i18n_page_settings_user from '@/locales/keys/i18n_page_settings_user.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { useTranslation } from 'react-i18next';

export function S_VIEW__user_achievment() {
  const { user_number } = use_slice_user(['user_number']);

  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_USER);

  function render_icon() {
    let out = null;

    let class_name = '!w-5 !h-5 !text-component-item-foreground';

    if (user_number == 1) {
      out = <ICON__wine_glass_solid className={class_name} />;
    } else if (user_number <= CONSTANTS__shared.USER_ACHIEVMENT_FAMILY) {
      out = <ICON__heart_pulse_solid className={class_name} />;
    } else if (user_number <= CONSTANTS__shared.USER_ACHIEVMENT_CLOSE_FRIENDS) {
      out = <ICON__gratipay_brands className={class_name} />;
    } else if (user_number <= CONSTANTS__shared.USER_ACHIEVMENT_FRIENDS) {
      out = <ICON__user_group_solid className={class_name} />;
    } else if (user_number <= CONSTANTS__shared.USER_ACHIEVMENT_EARLYBIRD) {
      out = <ICON__dove_solid className={class_name} />;
    }

    return out;
  }

  function get_name() {
    let out = null;

    if (user_number == 1) {
      out = t(i18n_page_settings_user.tabs.account.achivements_component.proximity_level.one);
    } else if (user_number <= CONSTANTS__shared.USER_ACHIEVMENT_FAMILY) {
      out = t(i18n_page_settings_user.tabs.account.achivements_component.proximity_level.family);
    } else if (user_number <= CONSTANTS__shared.USER_ACHIEVMENT_CLOSE_FRIENDS) {
      out = t(i18n_page_settings_user.tabs.account.achivements_component.proximity_level.close_friends);
    } else if (user_number <= CONSTANTS__shared.USER_ACHIEVMENT_FRIENDS) {
      out = t(i18n_page_settings_user.tabs.account.achivements_component.proximity_level.friends);
    } else if (user_number <= CONSTANTS__shared.USER_ACHIEVMENT_EARLYBIRD) {
      out = t(i18n_page_settings_user.tabs.account.achivements_component.proximity_level.early_bird);
    }

    return out;
  }

  if (user_number == CONSTANTS__shared.NUMBER_EMPTY_VALUE) return null;
  if (user_number == 0) return null;
  if (user_number > CONSTANTS__shared.USER_ACHIEVMENT_FAMILY) return null;

  return (
    <>
      <h3 className="text-xl ">{t(i18n_page_settings_user.tabs.account.achivements_component.title)}</h3>

      <div className="flex flex-col gap-2 text-bar-foreground w-full justify-start items-start text-left">
        <span className="flex flex-row gap-1">
          {render_icon()}
          {get_name()}
        </span>
        <span className="ml-1 text-left">{t(i18n_page_settings_user.tabs.account.achivements_component.description, { user_number: user_number })}</span>
      </div>
    </>
  );
}
